import { ParentShadowWalletInterface } from "../../../../interfaces/parent-shadow-wallet.interface";
import CoinsDisplay from "../../CoinsDisplay";

const ParentShadowWalletDetails = ({
  wallet,
  loading,
}: {
  wallet?: ParentShadowWalletInterface | null;
  loading?: boolean;
}) => {
  if (loading) {
    return (
      <div className="p-4 border rounded-lg shadow-sm bg-white">
        <p className="text-gray-500">Loading wallet details...</p>
      </div>
    );
  }

  if (!wallet) {
    return (
      <div className="p-4 border rounded-lg shadow-sm bg-white">
        <p className="text-gray-500">No parent shadow wallet found for this request.</p>
      </div>
    );
  }

  return (
    <div className="p-4 border border-yellow-400 rounded-lg shadow-sm bg-white">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-gray-800">
        <p>
          <span className="text-gray-500 font-semibold">Total Classes:</span>{" "}
          <CoinsDisplay value={wallet.totalNumberOfClasses} />
        </p>
        <p>
          <span className="text-gray-500 font-semibold">GC / Class:</span>{" "}
          <CoinsDisplay value={wallet.gcChargePerClass} />
        </p>
        <p>
          <span className="text-gray-500 font-semibold">Total GC Allocated:</span>{" "}
          <CoinsDisplay value={wallet.totalCoinsAllocated} />
        </p>
        <p>
          <span className="text-gray-500 font-semibold">Current Coins:</span>{" "}
          <CoinsDisplay value={wallet.currentCoins} />
        </p>
        <p>
          <span className="text-gray-500 font-semibold">Free Sessions:</span>{" "}
          {wallet.noOfSessionFree ?? 0}
        </p>
        <p>
          <span className="text-gray-500 font-semibold">Status:</span>{" "}
          {wallet.isActive ? "Active" : "Inactive"}
        </p>
      </div>
    </div>
  );
};

export default ParentShadowWalletDetails;
